module.exports = "<app-toolbar-content ng-transclude></app-toolbar-content>";


//////////////////
// WEBPACK FOOTER
// ./src/deprecated/directive/app/toolbar/template.html
// module id = 224
// module chunks = 0